module.exports = __webpack_public_path__ + "img/3.2df43e35.jpg";